import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton";
import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { useInputDialog } from "src/components/common/dialogs/input/useInputDialog.tsx";
import { WinnerImportApi } from "src/api/generated/erp/integrations/winner/api/winnerImportApi.ts";
import { uploadFile } from "src/utils/fileUploading.ts";
import { useGlobalInitData } from "src/contexts/GlobalInitDataContext.ts";

export interface ImportCustomerOrderFromWinnerButtonProps {
	onSubmit?: () => Promise<void>;
}

export const ImportCustomerOrderFromWinnerButton = ({ onSubmit }: ImportCustomerOrderFromWinnerButtonProps) => {
	const showInputDialog = useInputDialog();
	const { tenantConfig } = useTenantCustomizations();
	const { defaultSiteId } = useGlobalInitData();
	if (!tenantConfig.erp?.winnerIntegrationEnabled) return null;

	return (
		<AsyncMenuButton
			label={i18n.t("import_from_winner")}
			icon={faFileImport}
			onClick={async () => {
				const file = await showInputDialog({
					type: "singleFile",
					title: i18n.t("winner_file"),
					defaultValue: null,
					required: true,
				});
				if (file === undefined) return;

				const fileHandle = await uploadFile(file);

				await WinnerImportApi.importWinnerDesignsToCustomerOrder({
					siteId: defaultSiteId,
					winnerExportFileHandle: fileHandle,
				});
				await onSubmit?.();
			}}
		/>
	);
};
